import * as React from "react";
function SvgAlcmeon(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <g fill="#fff">
        <circle cx={13.25} cy={11.13} r={1.2} />
        <circle cx={18.75} cy={11.13} r={1.2} />
      </g>
      <g fill="none" stroke="#fff" strokeWidth={1.63}>
        <path d="M21.34 23.67c3.11-1.86 5.66-5.19 5.66-9.11 0-5.75-4.92-10.41-11-10.41S5 8.81 5 14.56a10.4 10.4 0 006.75 9.6l-1.6 3.69s8.24-2.45 11.19-4.18z" />
        <path
          strokeLinecap="round"
          d="M21.08 16.18A5.37 5.37 0 0116 19.57a5.37 5.37 0 01-5.06-3.31"
        />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgAlcmeon);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
